<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small text-center">
      <el-upload
        class="upload-demo"
        drag
        :action="uploadUrl"
        :before-upload="beforeUpload"
        :headers="uploadHeader"
        :data="this.$props.type"
        :on-success="onUploadSuccess"
        :on-error="onUploadError"
        :on-change="fileChange"
        :on-exceed="onExceed"
        :on-progress="onProgress"
        :http-request="customizeUploader"
        ref="upload"
        :auto-upload="true"
        v-loading="isUploading"
        element-loading-text="正在导入数据，请中途关闭此窗口，数据导入成功后，将自动关闭。"
        element-loading-spinner="el-icon-loading"
        :multiple="false"
        :show-file-list="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
      </el-upload>
      <div>
        <div v-for="(item, index) in fileArr" :key="index" class="cs-upload-item">
            <div>
                <i class="el-icon-document"></i>
                <span>{{ item.name }}</span>
                <span>{{ convertFileSize(item.size) }}</span>
                <span class="cs-color-green" v-if="item.successFlag">上传成功!</span>
            </div>
            <div v-if="item.progressFlag">
                <el-progress :text-inside="true" :stroke-width="24" :percentage="item.progressPercent"></el-progress>
            </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            type="error"
            show-icon
          >
            <template #title>
              <span v-html="errorMessage" />
            </template>
          </el-alert>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-upload-item{
    display: flex;
    flex-direction: column;
    margin-top: 5px;

    span{
        display: inline-block;
        margin-left: 5px;

        &:first-of-type{
            margin-left: 1px;
        }
    }
}
</style>

<script>
import {
    convertFileSize
} from "../../config/mUtils";
import {
  uploadFile,
  getUploadUrl,
  getUploadHeader
} from "../../service/common.service";
export default {
  props: [
    "submitBtnText",
    "supportedFile",
    "accepts",
    "tips",
    "type",
    "limit",
    "isVisible",
    "customizeUploader"
  ],
  data() {
    return {
      isUploading: false,
      isUploadSuccess: false,
      uploadHeader: getUploadHeader(),
      uploadUrl: getUploadUrl(),
      submitBtnClass: "info",
      showError: false,
      errorMessage: "",
      fileName: "",
      fileArr: [],
    };
  },
  methods: {
    onExceed(files, fileList) {},
    fileChange(file, fileList) {},
    beforeUpload(file) {
      this.clearMessages();
      this.isUploadSuccess = false;
      if (this.$props.accepts.indexOf(file.type) < 0) {
        this.showError = true;
        this.errorMessage =
          "不是所支持的" +
          this.$props.supportedFile +
          "文件, 请上传正确的文件格式";
        return false;
      }
      this.submitBtnClass = "primary";
      this.$emit("fileBeforeUpload");
      this.isUploading = true;
    },
    onProgress(event, file, fileList) {
      this.fileArr = fileList;
      this.fileArr.forEach((item) => {
        if (item.percentage == 100) {
        } else {
          item.progressFlag = true;
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      });
    },
    onUploadSuccess(res, file, fileList) {
      this.fileArr = fileList;
      this.fileArr.forEach((item, index) => {
        //item.progressFlag = false;
        if (item.status == "success") {
          item.successFlag = true;
        } else {
          item.successFlag = false;
        }
      });

      this.isUploadSuccess = true;
      this.submitBtnClass = "info";
      this.clearMessages();
      this.$refs.upload.clearFiles();
      this.$emit("fileUploaded", res);
      this.isUploading = false;
    },
    onUploadError(err) {
      this.isUploading = false;
      this.isUploadSuccess = false;
      this.showError = true;
      this.errorMessage = JSON.parse(err.message).Message.replaceAll("\r\n", "<br />");
      this.$emit("fileUploadError");
    },
    clearMessages() {
      this.showError = false;
      this.errorMessage = "";
    },
    submitFile() {
      this.$refs.upload.submit();
      // let _self = this;
      // this.$emit("fileUploaded", function(result) {
      //     if (!!result && result.success) {
      //         if (result.data) {
      //             _self.$emit("closeEditor");
      //         } else {
      //             _self.showError = true;
      //             _self.errorMessage = result.data.Message;
      //         }
      //     } else {
      //         _self.showError = true;
      //         _self.errorMessage = result.message;
      //     }
      // });
    },
    convertFileSize(fileSize){
        return convertFileSize(fileSize);
    }
  },
  watch: {
    isVisible: function () {
      if (!this.isVisible) {
        this.clearMessages();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fileHandler/fileUploader.vue